(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["p_plan"] && !Shopify.designMode) return;
  try {
    // --- Pack size qty update ---
  const updateQtySpans = () => {
    const packSizeEl = document.querySelector('[data-size]:has(input:checked)');
    if (!packSizeEl) return;
    const packSize = parseInt(packSizeEl.getAttribute('data-size'), 10) || 1;
    document.querySelectorAll('.global-product__plan-qty').forEach(qtyContainer => {
      const qtySpans = qtyContainer.querySelectorAll('.qty');
      if (qtySpans.length > 0) {
        const eachQty = Math.floor(packSize / qtySpans.length);
        qtySpans.forEach(span => {
          span.textContent = `${eachQty} x `;
        });
      }
    });
  };

  const updateSellingPlan = () => {
    const buyOnce = document.getElementById('buy_once');
    const buyPlan = document.getElementById('buy_plan');
    const planSelect = document.querySelector('select[name="selling_plan_select"]');
    const atcButtons = document.querySelectorAll('[data-product-atc]');
    const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
    let sellingPlan = '';

    if (buyPlan && buyPlan.checked && planSelect) {
      sellingPlan = planSelect.value;
      sellingPlanInput.value = sellingPlan;
    } else {
      sellingPlanInput.value = '';
    }

    atcButtons.forEach(btn => {
      btn.setAttribute('data-selling-plan', sellingPlan);
    });
  }

  const showOrHideSubscribe = () => {
    const buyPlan = document.getElementById('buy_plan');
    const subscribeLabel = document.querySelector('.global-product__plan label[for="buy_plan"]');
    const packVariant = document.querySelector('input[name="variant"]:checked');
    const packSize = packVariant.closest('[data-size]').dataset.size || 1;

    if (packSize == 1) {
      subscribeLabel.classList.add('disabled');
      document.querySelector('input#buy_plan').checked = false;
      document.querySelector('input#buy_once').checked = true;

      updateSellingPlan();
    } else {
      subscribeLabel.classList.remove('disabled');
    }
  }
  showOrHideSubscribe();

  document.getElementById('buy_plan')?.addEventListener('change', (e) => {
    if (e.target.checked) {
      const selectedPack = document.querySelector('[data-size] input[name="variant"]:checked');
      if (selectedPack) {
        const packSize = parseInt(selectedPack.closest('[data-size]').dataset.size, 10) || 1;
        if (packSize === 1) {
          const pack2 = document.querySelector('[data-size="2"] input[name="variant"]');
          if (pack2) {
            pack2.checked = true;
            pack2.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    }
  });

  // When variant radio changes
  document.querySelectorAll('input[name="variant"]').forEach(radio => {
    radio.addEventListener('change', () => {
      const id = radio.id.split('_')[2];
      document.querySelectorAll('.global-product__plan .price').forEach(p => p.style.display = 'none');
      document.querySelectorAll(`.global-product__plan .price-${id}`).forEach(p => p.style.display = 'block');
      updateQtySpans();
      showOrHideSubscribe();
      const hiddenInput = document.querySelector('input[name="id"]');
      if (hiddenInput) {
        hiddenInput.value = radio.value;
        // Trigger change event to notify Shopify's dynamic checkout buttons
        hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    if(radio.checked) {
      const hiddenInput = document.querySelector('input[name="id"]');
      if (hiddenInput) {
        hiddenInput.value = radio.value;
        // Trigger change event to notify Shopify's dynamic checkout buttons
        hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });

  // When selling plan radio changes
  document.querySelectorAll('input[name="selling_plan_option"]').forEach(radio => {
    radio.addEventListener('change', () => {
      const planSelect = document.querySelector('select[name="selling_plan_select"]');
      if (radio.id === 'buy_once' && planSelect) {
        // planSelect.selectedIndex = -1;
      }
      updateSellingPlan();
    });
  });

  // When select changes
  const planSelect = document.querySelector('select[name="selling_plan_select"]');
  if (planSelect) {
    planSelect.addEventListener('change', () => {
      const buyPlan = document.getElementById('buy_plan');
      if (buyPlan) buyPlan.checked = true;

      const pack2 = document.querySelector('[data-size="2"] input[name="variant"]');
      if (pack2) {
        pack2.checked = true;
        pack2.dispatchEvent(new Event('change', { bubbles: true }));
      }
      
      updateSellingPlan();
    });
  }

  // Initial update on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', () => {
    updateQtySpans();
    updateSellingPlan();
  });
  } catch(e) { console.error(e); }
})();

})();
